import { REQUEST_DOWNLOAD_HELP, RESPONSE_DOWNLOAD_HELP, REQUEST_DOWNLOAD_HELP_FAULURE } from "../actions/downloadFilesActions";

import { states } from "./queriesStates";

const initialState = {
  downloadHelpFileDataState: states.NOT_REQUESTED,
  errors: [],
};

const downloadFilesReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_DOWNLOAD_HELP:
      return Object.assign({}, state, {
        downloadHelpFileDataState: states.REQUEST,
      });
    case RESPONSE_DOWNLOAD_HELP:
      return Object.assign({}, state, {
        downloadHelpFileDataState: states.READY,
      });
    case REQUEST_DOWNLOAD_HELP_FAULURE:
      return Object.assign({}, state, {
        downloadHelpFileDataState: states.FAILURE,
        errors: action.errors,
      });

    default:
      return state;
  }
};

export default downloadFilesReducer;
